"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsset = exports.ASSET_QUERY_KEY = void 0;
const react_query_1 = require("@tanstack/react-query");
const SearchService_1 = require("src/contexts/SearchService");
exports.ASSET_QUERY_KEY = ['search', 'assets'];
const useAsset = (mint) => {
    return (0, react_query_1.useQuery)({
        queryKey: [...exports.ASSET_QUERY_KEY, mint],
        queryFn: () => SearchService_1.searchService.search(mint),
        enabled: !!mint,
        staleTime: Infinity,
        select: (data) => data[0],
    });
};
exports.useAsset = useAsset;
